// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  useEmulators: true,
  firebase: {
    apiKey: "AIzaSyCkQG_ZCmobd7eukcpRUqpe8rOEY7NawSo",
    authDomain: "oneszerostech.firebaseapp.com",
    projectId: "oneszerostech",
    storageBucket: "oneszerostech.appspot.com",
    messagingSenderId: "453225294238",
    appId: "1:453225294238:web:7ffc26c412902cdf8cce8f",
    measurementId: "G-5T5ZSWPB0L"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
